import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Link, Route, Routes, Switch } from "react-router-dom";
import { GlobalState } from "./Globalstate";
import AppContainer from "./AppContainer";
import JobApplication from "./Pages/JobApplication";
import TrackingPage from "./Pages/TrackingPage";
import PaymentPage from "./Pages/PaymentPage";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <GlobalState>
      {/* <ToastContainer className="foo" /> */}
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<AppContainer />} />
        <Route path="/track-order" element={<TrackingPage />} />
        <Route path="/payment" element={<PaymentPage />} />
            <Route exact path="/jobapplication" element={<JobApplication />} />
        </Routes>
      </BrowserRouter>
    </GlobalState>
  );
}

export default App;
